import api from '@/js/services/axios'
import { isSignupClosed } from '@/domains/bookings/util/signupWindow'

export default {
  getAll () {
    return new Promise((resolve, reject) => {
      api.get('public/v1/events')
        .then(response => {
          var data = response.data
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getByUuid (uuid) {
    return new Promise((resolve, reject) => {
      api.get('public/v1/events/' + uuid)
        .then(response => {
          var data = response.data
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getWeeklyByOrganization(organizationId, from, to){
    const params = new URLSearchParams()
    params.set('from', from)
    params.set('to', to)
    return new Promise((resolve, reject) => {
      api.get('public/v1/org/' + organizationId + '/events/find-weekly?' + params.toString())
        .then(response => {
          var data = response.data
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getWeeksAvailable(organizationId){
    return new Promise((resolve, reject) => {
      api.get('public/v1/org/' + organizationId + '/events/weeks-available')
        .then(response => {
          var data = response.data
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  _processEvents(events, myClass){
    return events.map(event => {
      
      const hasDisplayAvailableSpots = event.display_available_spots !== null && event.display_available_spots !== undefined
      const participantLimit = Number(event.participant_limit)
      const participantCount = Number(event.participant_count)
      const isAtCapacity = Number.isFinite(participantLimit) && participantLimit > 0
        && Number.isFinite(participantCount) && participantCount >= participantLimit
      event.isEventFull = (hasDisplayAvailableSpots && event.display_available_spots === 0) || isAtCapacity
        

      if (!myClass){
        return event
      }

      event.signupClosed = isSignupClosed(event.start_time, myClass.close_signup_before_minutes)

      return event
    })
  }
}
